import { authApiCall } from "../../auth";

export const updatePointsRequest = (id, status, amount) => {

  return authApiCall({
    url: `/points/update-request/${id}/`,
    method: 'patch',
    data: { status, amount}
  });
};